//imports
import { HashRouter,Routes, Route } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Subscribe from './pages/Subscribe';
import OtpConfirm from './pages/OtpConfirm';
import ErrorBoundary from './components/ErrorBoundary';
import Subscriptions from './pages/subscriptions/Subscriptions';
import Winners from './pages/winners/Winners';
import Test from './pages/tests/Tests';

function App(){
     return (
         <ErrorBoundary>
             <HashRouter>
                 <Routes>
                    <Route path="/login" element={<Login />}/>
                    <Route path="/otpConfirm" element={<OtpConfirm />}/>
                    <Route path="/subscribe" element={<Subscribe />}/>
                    <Route path="/" element={<Dashboard />}/>
                    <Route path="/winners" element={<Winners />}/>
                    <Route path="/subscriptions" element={<Subscriptions />}/>
                    <Route path="/tests" element={<Test />}/>
                </Routes>
             </HashRouter>
        </ErrorBoundary>
    );
}
export default App;